import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  ["Πόσο κοστίζουν τα μεταφορικά;", "Standard €3.50, Express €6.90. Δωρεάν μεταφορικά για παραγγελίες άνω των €80."],
  ["Πόσο χρόνο κάνει η παράδοση;", "Standard 2-4 εργάσιμες, Express 1-2 εργάσιμες σε όλη την Ελλάδα."],
  ["Μπορώ να πληρώσω με αντικαταβολή;", "Ναι! Προσφέρουμε αντικαταβολή με μικρή επιπλέον χρέωση €2."],
  ["Πώς μπορώ να επιστρέψω ένα προϊόν;", "Έχεις 14 ημέρες για δωρεάν επιστροφή. Επικοινώνησε μαζί μας με τον αριθμό παραγγελίας."],
  ["Τα προϊόντα είναι true to size;", "Τα περισσότερα είναι oversized fit. Δες τον οδηγό μεγεθών σε κάθε προϊόν."],
];

export default function Contact() {
  const { settings } = useOutletContext();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = (e) => { e.preventDefault(); toast.success("Το μήνυμα στάλθηκε! Θα επικοινωνήσουμε σύντομα."); setForm({ name: "", email: "", message: "" }); };
  const inp = "w-full bg-[#0A0A0B] border border-zinc-700 rounded px-4 py-3 text-sm outline-none focus:border-[#FF2E4C]";

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12 py-8 sm:py-12">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#FF2E4C] mb-1">ΕΠΙΚΟΙΝΩΝΙΑ</p>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase tracking-tighter mb-10">GET IN TOUCH</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <div className="space-y-4 mb-8">
            <a href={settings?.instagram || "https://instagram.com/skgwear"} target="_blank" rel="noreferrer" className="flex items-center gap-3 card-surface rounded-lg p-4 hover:border-[#FF2E4C] transition-colors"><Instagram className="w-5 h-5 text-[#FF2E4C]" /><div><p className="text-sm font-semibold">Instagram</p><p className="text-xs text-zinc-500">@skgwear</p></div></a>
            <a href={`mailto:${settings?.contact_email || "info@skgwear.gr"}`} className="flex items-center gap-3 card-surface rounded-lg p-4 hover:border-[#FF2E4C] transition-colors"><Mail className="w-5 h-5 text-[#FF2E4C]" /><div><p className="text-sm font-semibold">Email</p><p className="text-xs text-zinc-500">{settings?.contact_email || "info@skgwear.gr"}</p></div></a>
            <div className="flex items-center gap-3 card-surface rounded-lg p-4"><MapPin className="w-5 h-5 text-[#FF2E4C]" /><div><p className="text-sm font-semibold">Έδρα</p><p className="text-xs text-zinc-500">Θεσσαλονίκη, Ελλάδα</p></div></div>
          </div>
          <form onSubmit={submit} className="space-y-3">
            <input placeholder="Όνομα" value={form.name} onChange={set("name")} className={inp} data-testid="contact-name" required />
            <input type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inp} data-testid="contact-email" required />
            <textarea placeholder="Μήνυμα" rows={5} value={form.message} onChange={set("message")} className={inp} data-testid="contact-message" required />
            <button className="btn-red w-full py-3.5 text-sm font-bold tracking-widest uppercase rounded" data-testid="contact-submit">ΑΠΟΣΤΟΛΗ</button>
          </form>
        </div>
        <div>
          <h2 className="font-display text-2xl font-black uppercase tracking-tight mb-4">FAQ</h2>
          <Accordion type="single" collapsible>
            {FAQ.map(([q, a], i) => (
              <AccordionItem key={i} value={`f${i}`} className="border-zinc-800">
                <AccordionTrigger className="text-sm text-left">{q}</AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
